"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  COMPANY_TO_ADVISOR: null,
  COMPANY_TO_BOARD_MEMBER: null,
  COMPANY_TO_CONTRACTOR: null,
  COMPANY_TO_MANAGER: null,
  COMPANY_TO_OWNER: null,
  COMPANY_TO_PARTNER: null,
  COMPANY_TO_RESELLER: null
});

exports.default = _default;
module.exports = exports.default;